import { NextPage } from 'next';
import React from 'react';

import GiftingSeasonArticle1ImageUrl from '@/assets/seasonal-guides/winter/gifting-season-article-1.jpg';
import GiftingSeasonArticle2ImageUrl from '@/assets/seasonal-guides/winter/gifting-season-article-2.jpg';
import GiftingSeasonArticle3ImageUrl from '@/assets/seasonal-guides/winter/gifting-season-article-3.jpg';
import GiftingSeasonIconSvg from '@/assets/seasonal-guides/winter/gifting-season-icon.svg';
import GiftingSeasonMediaUrl from '@/assets/seasonal-guides/winter/gifting-season-media.jpg';
import ogThumbnailUrl from '@/assets/seasonal-guides/winter/og-thumbnail.gif';
import WarmerClimatesArticle1ImageUrl from '@/assets/seasonal-guides/winter/warmer-climates-article-1.jpg';
import WarmerClimatesArticle2ImageUrl from '@/assets/seasonal-guides/winter/warmer-climates-article-2.jpg';
import WarmerClimatesArticle3ImageUrl from '@/assets/seasonal-guides/winter/warmer-climates-article-3.jpg';
import WarmerClimatesIconSvg from '@/assets/seasonal-guides/winter/warmer-climates-icon.svg';
import WarmerClimatesMediaUrl from '@/assets/seasonal-guides/winter/warmer-climates-media.jpg';
import WinterTravels1ImageUrl from '@/assets/seasonal-guides/winter/winter-travels-article-1.jpg';
import WinterTravels2ImageUrl from '@/assets/seasonal-guides/winter/winter-travels-article-2.jpg';
import WinterTravels3ImageUrl from '@/assets/seasonal-guides/winter/winter-travels-article-3.jpg';
import WinterTravelsIconSvg from '@/assets/seasonal-guides/winter/winter-travels-icon.svg';
import WinterTravelsListItem1ImageUrl from '@/assets/seasonal-guides/winter/winter-travels-list-item-1.png';
import WinterTravelsListItem2ImageUrl from '@/assets/seasonal-guides/winter/winter-travels-list-item-2.png';
import WinterTravelsListItem3ImageUrl from '@/assets/seasonal-guides/winter/winter-travels-list-item-3.png';
import WinterTravelsMediaUrl from '@/assets/seasonal-guides/winter/winter-travels-media.jpg';
import { ExternalFonts } from '@/components/common/ExternalFonts';
import HeadMeta from '@/components/static-pages/HeadMeta';
import { WinterGuidesTemplate } from '@/components/templates/seasonal-guides/WinterGuidesTemplate';

const SeasonalWinterGuides: NextPage = () => {
  return (
    <>
      <ExternalFonts href="https://use.typekit.net/ilj4txf.css" />

      <HeadMeta title="Outdoorsy Winter Guide" thumbnailURL={ogThumbnailUrl} />

      <WinterGuidesTemplate
        sections={[
          {
            id: 'gifting-season',
            tag: 'Gifting season',
            heading: {
              icon: <GiftingSeasonIconSvg />,
              title: `Give the gift of getting outside`,
              description: `Share your love of travel with our custom gift cards, perfect for the weekend warriors, families on a budget, honeymooners, parents shuttling kids to soccer games, snowbirds, 9-to-5ers, tailgaters, and all-around nature lovers.`,
              textColor: '#FFFFFF',
              linkText: `Order gift cards`,
              linkBackgroundColor: '#FFFFFF',
              linkTextColor: '#212831',
              linkUrl: '/gift-cards',
              imageUrl: GiftingSeasonMediaUrl,
              imageBlurDataUrl:
                'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEAkACQAAD/2wBDAAMCAgICAgMCAgIDAwMDBAYEBAQEBAgGBgUGCQgKCgkICQkKDA8MCgsOCwkJDRENDg8QEBEQCgwSExIQEw8QEBD/2wBDAQMDAwQDBAgEBAgQCwkLEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBD/wAARCAAOAA8DAREAAhEBAxEB/8QAFAABAAAAAAAAAAAAAAAAAAAABv/EACEQAAICAgICAwEAAAAAAAAAAAECAwUEEQYSBwgAEyEi/8QAGAEAAgMAAAAAAAAAAAAAAAAABQYBAwT/xAAqEQABAgQEAwkAAAAAAAAAAAABAxEAAgQhBRIxQQYVURMUMmFxgaGx8f/aAAwDAQACEQMRAD8Ac889VvZe+pKm0bGpsRq0zPbCe7i+6WBZmlIR1Qp1KBOw2uyo3ofnyC5EV5XgHSc7tK3yKlRR5rT8m0c6zGDZQzwSrJippYZdiMsuk2EcqBsH+t/MKS6itZ2MrEN75t76M0FqrClKPDOYKAhiHfobAtrr9i0OzzfyF4Qzebcnqs4YNhYwwWtjW41lkZtcScpy0uMMkd8eSUSguo7KOulOjsLNRxPPPW0lGjK0i8rufECbjyb5hhpMASkpl6uoOaZKbK2kpAa/V4N+tPh+m8j8hsL6isp6lIszIgix5k+1YWKCWYJ0ZR0ZpQQNbBB/SDoNGGUcqU/eVC8wf0uP2BnEOMLVdPy5ICVMgE2u4PXfaP/Z',
              imagePosition: 'right',
              backgroundImageOpacity: 0.03,
              backgroundColor: '#284941',
            },
            articles: [
              {
                url: 'https://www.outdoorsy.com/blog/holiday-decorations-for-your-rv-rental',
                imageUrl: GiftingSeasonArticle1ImageUrl,
                imageBlurDataUrl:
                  'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAAAAAAD/2wBDAAMCAgICAgMCAgIDAwMDBAYEBAQEBAgGBgUGCQgKCgkICQkKDA8MCgsOCwkJDRENDg8QEBEQCgwSExIQEw8QEBD/2wBDAQMDAwQDBAgEBAgQCwkLEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBD/wAARCAAOAA8DASIAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAACAIH/8QAJBAAAgEDBAEFAQAAAAAAAAAAAQIDBAURAAYSIRMIFiMxQpH/xAAVAQEBAAAAAAAAAAAAAAAAAAADBP/EACERAAIBAwMFAAAAAAAAAAAAAAERIQIDBABBYQYHEjGh/9oADAMBAAIRAxEAPwDToKqGpSldCQ1avOBGGGfoEgA9kgEZ1U08FMvknnjiUfp3Cj+nRiiuG0dqiSDc/u+5rQzxR/Df3U+Ng/EAkY6I7GMHkfrGkZPsSX1B2m24q6Km2+1DEVtj0ssBJbjIpaWKYnK8QAQBkch0GOpLHX12oVedkH0kePsztBXOlzu1NnHqoIyCAW3SDvCRYiJBkPdD/9k=',
                title: 'Holiday decor for your RV',
                description: 'Deck the halls',
                backgroundColor: '#284941',
              },
              {
                url: 'https://www.outdoorsy.com/blog/holiday-experience-gifts',
                imageUrl: GiftingSeasonArticle2ImageUrl,
                imageBlurDataUrl:
                  'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAAAAAAD/2wBDAAMCAgICAgMCAgIDAwMDBAYEBAQEBAgGBgUGCQgKCgkICQkKDA8MCgsOCwkJDRENDg8QEBEQCgwSExIQEw8QEBD/2wBDAQMDAwQDBAgEBAgQCwkLEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBD/wAARCAAOAA8DASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAABAUGB//EACUQAAIBAwMDBQEAAAAAAAAAAAECAwQREgAFBgchQQgUFSJxMf/EABQBAQAAAAAAAAAAAAAAAAAAAAb/xAAjEQABAgUDBQAAAAAAAAAAAAABBBEAAgUhMQMiYQYTUZGh/9oADAMBAAIRAxEAPwASfrt1GhPuPnUhjggKGB44JsmQZAlrXLEXUj8t4OrDZvUzt0lPBVch4qzQ1QZo3oHAkTEAYsjmxJORJDdv5bWHPzbbUpw9dsCT4yl2ZTECsQBJVA8bAN4yN/zS6p5xT5DcKLjO2x09ZJK0NPLCsgjjy+oJAUMwHa9hoUg6lraFu2pM2MuQLG2761uYTraJSlwbVTCXkASk3F9h9P5xkR//2Q==',
                title: 'Best gifts for any holiday',
                description: 'Add to cart',
                backgroundColor: '#284941',
              },
              {
                url: 'https://www.outdoorsy.com/blog/10-reasons-to-list-your-rv-on-outdoorsy',
                imageUrl: GiftingSeasonArticle3ImageUrl,
                imageBlurDataUrl:
                  'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAAAAAAD/2wBDAAMCAgICAgMCAgIDAwMDBAYEBAQEBAgGBgUGCQgKCgkICQkKDA8MCgsOCwkJDRENDg8QEBEQCgwSExIQEw8QEBD/2wBDAQMDAwQDBAgEBAgQCwkLEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBD/wAARCAAOAA8DASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAwYHCP/EACQQAAEEAAUEAwAAAAAAAAAAAAECAwQRAAUGEiEHEyIxFkHR/8QAFAEBAAAAAAAAAAAAAAAAAAAABP/EACIRAAECBQQDAAAAAAAAAAAAAAECAwAFERIhBBMxoWGxwf/aAAwDAQACEQMRAD8A0l8aQPMPtefN7jR/cEXlJkNtxzMjKEUFCQlQBTZs3Qs8n7xN+hHQyE9pZjOmNY57lMoyCw/DivB6LuQogV3BZSdvPCTRrDhq7pPqvLoLMxOsoakRViPFMaAuLIQkg2FO91zdwD7SSb94C7M9ah/ZS6k0PNpGe+jBG5PL1MB0oWK8i5Jx495p9j//2Q==',
                title: 'How to make Christmas cash',
                description: 'Reasons to host',
                backgroundColor: '#284941',
              },
            ],
            readingList: {
              title: 'Rigs ready for snow, sand, and slow rolling',
              items: [
                {
                  url: 'https://www.outdoorsy.com/promos/holidays/holidays-rv-rentals',
                  title: `RV rentals for the holidays`,
                  linkText: 'Celebrate on the road',
                },
                {
                  url: 'https://www.outdoorsy.com/promos/holidays/new-years-rv-rentals',
                  title: `RV rentals for New Years`,
                  linkText: 'Start off 2025 right',
                },
                {
                  url: 'https://www.outdoorsy.com/blog/spring-rv-trips-that-are-family-friendly',
                  title: `Plan ahead for spring`,
                  linkText: 'Family-friendly trips',
                },
              ],
            },
          },
          {
            id: 'winter-travels',
            tag: 'Winter travels',
            heading: {
              icon: <WinterTravelsIconSvg />,
              title: `Ski resorts that allow RVs to camp out`,
              description: `Stay overnight at these mountains to catch first chair—and save money on hotels and airfare.`,
              textColor: '#FFFFFF',
              linkText: `Chase the powder`,
              linkBackgroundColor: '#5C9BE5',
              linkTextColor: '#FFFFFF',
              linkUrl:
                'https://www.outdoorsy.com/blog/the-best-rv-campervan-friendly-ski-resorts-in-the-u-s',
              imageUrl: WinterTravelsMediaUrl,
              imageBlurDataUrl:
                'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEAkACQAAD/2wBDAAMCAgICAgMCAgIDAwMDBAYEBAQEBAgGBgUGCQgKCgkICQkKDA8MCgsOCwkJDRENDg8QEBEQCgwSExIQEw8QEBD/2wBDAQMDAwQDBAgEBAgQCwkLEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBD/wAARCAAOAA8DAREAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAABQcJ/8QAJhAAAgICAQMCBwAAAAAAAAAAAQIDBAURBgAHEiExCBMiIzJBcf/EABcBAAMBAAAAAAAAAAAAAAAAAAIFBgD/xAAjEQACAQMDBAMAAAAAAAAAAAABAgADERIEBSEGIkFRMYHw/9oADAMBAAIRAxEAPwBbuBie53EHyEGK7OYHMW6YjdKUMN1LE6MdbiDj7umBLePoAR6nfTk9bvQ1tPQ6nLJwSCo449nx+v4k03SWnekatADj2ZKuQy/HQiRJhOwKYeFo1lZamNhkIB9gzSSEq2iAV0CNf3pq28PVN8jApbMlJccRNE+R9u6fKFxUwz2VoZLBXlvY7JxSh7Nd/wAZI9sPrikTaSRtsMNfsAifcBzcj4lAvbFKfG4OPUp1eVrMuQtyXrHkSU+c4UOYwxJRT4g+GyAd69+soCk4wmdnAyN7C31P/9k=',
              imagePosition: 'left',
              backgroundImageOpacity: 0.03,
              backgroundColor: '#0F3047',
            },
            articles: [
              {
                url: 'https://www.outdoorsy.com/blog/the-best-destinations-for-winter-rving',
                imageUrl: WinterTravels1ImageUrl,
                imageBlurDataUrl:
                  'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEAkACQAAD/2wBDAAMCAgICAgMCAgIDAwMDBAYEBAQEBAgGBgUGCQgKCgkICQkKDA8MCgsOCwkJDRENDg8QEBEQCgwSExIQEw8QEBD/2wBDAQMDAwQDBAgEBAgQCwkLEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBD/wAARCAANAA8DAREAAhEBAxEB/8QAFAABAAAAAAAAAAAAAAAAAAAACP/EACUQAAEEAQQBBAMAAAAAAAAAAAECAwQFEQAGEiEHCBMUMSRBUf/EABYBAQEBAAAAAAAAAAAAAAAAAAQFA//EACURAAECBQMEAwAAAAAAAAAAAAECEQADBCExBRJBEyJRcZHh8f/aAAwDAQACEQMRAD8ASmyHo1naSpS2VvORrZcda23Cv5BbjBRK8jiQoKCSPvCT/dFk6fUoPUqVlSiBjDX7S4YiKlXrFHMT0aKWEIBVci7sGUli4IZndmaDp61ZcWBAhU3yi61LtEPewkkhDQZdPAhXZIWQc/vOq2lUq6fcpRDDA5D8XH7ETW9Ql1ZQlCTuIubMpuQxyxxxi8L5/wAN7bp6x+NUW97BakWT9r+PMSFBbrQaLfJSCSgJT1nvJznWipi5huW9QNEtEm4S/t/qC/6wPEu1Ie3KO8VLu5cp6yRXrVLnB3LXsPOZ7RnlyQnvP1kY02mUQjZ4+cwCoZU7ezPxxjxH/9k=',
                title: 'Best spots for winter RVing',
                description: 'See some snow',
                backgroundColor: '#0F3047',
              },
              {
                url: 'https://www.outdoorsy.com/blog/keeping-pets-warm-for-fall-and-winter-rving',
                imageUrl: WinterTravels2ImageUrl,
                imageBlurDataUrl:
                  'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEAkACQAAD/2wBDAAMCAgICAgMCAgIDAwMDBAYEBAQEBAgGBgUGCQgKCgkICQkKDA8MCgsOCwkJDRENDg8QEBEQCgwSExIQEw8QEBD/2wBDAQMDAwQDBAgEBAgQCwkLEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBD/wAARCAANAA8DAREAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAABAYI/8QAJhAAAQMCBgAHAAAAAAAAAAAAAQIDBAURAAYHEiExExQiQWGBgv/EABcBAQEBAQAAAAAAAAAAAAAAAAUEAgP/xAApEQABAwMDAgUFAAAAAAAAAAABAgQRAAMhBTFREkEGFGJxgaGxweHw/9oADAMBAAIRAxEAPwDTND1UoM6MmQX3IrfV5jewD9C4xlyh63BISFfIH3iuLJxpbwhJUpBPpJH0mh5Q1qoWd4EybBjONeTlOMbQFOlxsKIQ6naOlAdHkHj5xHdduUEBKBnuVAe4yRMcil06czSCblw4OyUqUYnBPSDE8HNQz+maJsdELMGZ6rVmfDKSl50oSq4tcpQQkkexIuDhK/pPmVEi6oZB7HbidqGZeKAwSAWyFGCJymZ3mDmiUjRWhUFa0wqpNQl07glBDYJsBdZT6lGwAHI+8XWmyLQ6Yn+4ohzql92srkgHg/nf9Yr/2Q==',
                title: 'How to keep pets warm',
                description: 'Cuddle up together',
                backgroundColor: '#0F3047',
              },
              {
                url: 'https://www.outdoorsy.com/blog/5-gourmet-hot-cocoa-recipes-to-keep-you-warm-while-camping',
                imageUrl: WinterTravels3ImageUrl,
                imageBlurDataUrl:
                  'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEAkACQAAD/2wBDAAMCAgICAgMCAgIDAwMDBAYEBAQEBAgGBgUGCQgKCgkICQkKDA8MCgsOCwkJDRENDg8QEBEQCgwSExIQEw8QEBD/2wBDAQMDAwQDBAgEBAgQCwkLEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBD/wAARCAANAA8DAREAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAABgj/xAAkEAABBAIBBAIDAAAAAAAAAAABAgMEEQUGEwASITEHURRCYv/EABgBAAIDAAAAAAAAAAAAAAAAAAUGAQME/8QAJxEAAQMBBwQDAQAAAAAAAAAAAQIDEQAEBQYhMUFREhNx0VKBkcH/2gAMAwEAAhEDEQA/AK91L5RxOYCGJktCFrX2h0kCjdUtP639+uk2zX40XO06fv370p5vHCFqaa77CTHB/h38a8TTFnYo70h+NEmMvfjOll4NrB4nQkKKFV6V2qSa/offRVxUEEb0ttNyD1CIqT39Rx2RkYmRiH5WJVjHg6eJ5TvOeRCkhRWSQE9lUCLCjfRIYZsTQUUJzPMnaOeDWc4/vZ/oS8qUjYQNwfjOoFPNF1eLr+R2HaMnk8plHtllsSVMmUWm4vE0UBKALu+/2fNJSPNX1Uq6WgkIBiB+nnWpOJLQ6oqInORMGBwMvJnU76V//9k=',
                title: '5 gourmet hot cocoa recipes',
                description: 'Warm your insides',
                backgroundColor: '#0F3047',
              },
            ],
            readingList: {
              title: 'Ways to fend off the cold temps',
              items: [
                {
                  url: 'https://www.amazon.com/s?k=little+buddy+heater&crid=3K43QHIJUZIRD&sprefix=little+buddy+heater%2Caps%2C267&linkCode=ll2&tag=outdoorsy0d-20&linkId=a95ab386ed32211b5e77466656223026&language=en_US&ref_=as_li_ss_tl',
                  title: `Keep warm with the Little Buddy heater`,
                  linkText: 'Crank the heat',
                },
                {
                  url: 'https://www.outdoorsy.com/promos/heater-rv-rentals',
                  title: `RV rentals with heaters to keep you cozy`,
                  linkText: 'Fend off freezing',
                },
                {
                  url: 'https://www.amazon.com/s?k=Wool+Socks&crid=1S2LJDI664OXV&sprefix=wool+socks%2Caps%2C199&linkCode=ll2&tag=outdoorsy0d-20&linkId=ac8febb4d9a6fe80898661f590800d29&language=en_US&ref_=as_li_ss_tl',
                  title: `Everyone needs a pair of these wool socks`,
                  linkText: 'No cold toes',
                },
              ],
            },
            banners: [
              {
                type: 'RVRentals',
                title: 'Snug RVs for a winter getaway',
                filters: {
                  'price[max]': '250',
                  score: '5',
                  'filter[feature]': 'heater,stove,inside_shower',
                },
              },
              {
                type: 'Basic',
                title: 'Find the right vehicle for winter',
                backgroundColor: '#0F3047',
                textColor: '#FFFFFF',
                items: [
                  {
                    image: {
                      src: WinterTravelsListItem1ImageUrl.src,
                      width: 49,
                      height: 49,
                      blurDataUrl:
                        'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAMAAAAMCGV4AAAAUVBMVEVHcEz///////////////////////////////////////////////////////////////////////////////////////////////////////9jlXTzAAAAG3RSTlMAGiO3E4MIKzMDs3pB1Y07vnIeVWEOqpmjyksxRzGRAAAAeElEQVQI10XORw4DMQgFUHDBvU5N7n/QOMxY/gvMwxICgEPtk9Jt4I0LPqLRUry2lTudH6p8Kh57fqL03pfRCImjotyc2/9fj78ptBZSnBZBj4Q+TQjqAHTTpfasRbXTKpIxVI7pFbbdCaxZ3i6CrJcdjRV8J/QTfwUOBBivHvW4AAAAAElFTkSuQmCC',
                    },
                    linkText: 'Vehicles with hot showers',
                    linkUrl: '/rv-search?filter%5Bfeature%5D=inside_shower%2Chot_water',
                  },
                  {
                    image: {
                      src: WinterTravelsListItem2ImageUrl.src,
                      width: 49,
                      height: 49,
                      blurDataUrl:
                        'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAOCAMAAADHVLbdAAAAb1BMVEVHcEz///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////9Eya1FAAAAJXRSTlMAupQHw6bIRauwEr4dKZuOZoVTbWN4JD7tDU6y4PdeOcwzNdVun5Uk6gAAAJ5JREFUCNc1jlkSgzAMQ22ThCxkI1B26Hb/M9YM9H14RpY0NtRZfeIOJ/WLB4mwGNMA2CxcqkDLcVtCy654DMoDunUVeGozNeihx4AUKjvQqJ4jgU9a93Ov1Lq5nDhX2WkXG0U3V3DxRcKOqzcJfSwx/91BvEGWFjV1lqU1Hd9CKWUviTNFT7xt6i5ILx4Aar57RR+O3zb2ks1y7BHgB734B/LBXBmTAAAAAElFTkSuQmCC',
                    },
                    linkText: 'Vehicles equipped with 4x4',
                    linkUrl:
                      '/rv-search?filter%5Btype%5D=c%2Cb%2Ca%2Ctruck-camper%2Ccamper-van%2Cother&filter%5Bkeywords%5D=4x4',
                  },
                  {
                    image: {
                      src: WinterTravelsListItem3ImageUrl.src,
                      width: 49,
                      height: 49,
                      blurDataUrl:
                        'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAMAAAAMCGV4AAAAVFBMVEVHcEz///////////////////////////////////////////////////////////////////////////////////////////////////////////+DS+nTAAAAHHRSTlMAsq1MCVBctXcijUUuBNWjwW02Dce8llQUQIWbYKeZRQAAAHJJREFUCNdVz9cOwzAIBVCPGBvjnTir//+frVSP5L4dQAgY+wV1SIXNWFtMXB02LkJ+SLuYh5WW+vR+mkuNqjzNnYVX/xzrW9+olzFTMybilNyYN/sR4LadPoKIVfK1F/ZsNgti6b7qQbLC/Ae2EMz/2i/8aARuIEtbswAAAABJRU5ErkJggg==',
                    },
                    linkText: 'Vehicles with heaters',
                    linkUrl: '/rv-search?filter%5Bfeature%5D=heater',
                  },
                ],
              },
            ],
          },
          {
            id: 'warmer-climates',
            tag: 'Warmer climates',
            heading: {
              icon: <WarmerClimatesIconSvg />,
              title: `Escape the cold for these warmer destinations`,
              description: `When warming up by the fire isn't enough, head to the beach or desert instead.`,
              textColor: '#212831',
              linkText: `Seek the sunshine`,
              linkBackgroundColor: '#00A876',
              linkTextColor: '#FFFFFF',
              linkUrl: 'https://www.outdoorsy.com/blog/warm-weather-winter-getaways',
              imageUrl: WarmerClimatesMediaUrl,
              imageBlurDataUrl:
                'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEAkACQAAD/2wBDAAMCAgICAgMCAgIDAwMDBAYEBAQEBAgGBgUGCQgKCgkICQkKDA8MCgsOCwkJDRENDg8QEBEQCgwSExIQEw8QEBD/2wBDAQMDAwQDBAgEBAgQCwkLEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBD/wAARCAAOAA8DAREAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAABQb/xAAjEAACAQQCAgIDAAAAAAAAAAABAgMEBQYRABIiMQchExRB/8QAFgEBAQEAAAAAAAAAAAAAAAAABwME/8QAJREAAQMEAQQCAwAAAAAAAAAAAQIDEQAEITFBBRJRYQYTMlLw/9oADAMBAAIRAxEAPwCbb4ouNJGI57xR1UMVNvsZEaX6b6dipPba72QB6U/3jFYdTa6dAcuwthCQmCJWCDAlQnuJ0ZA0MTRDd2D19P1W5S6ok4ICSIzg6je6m7niVvs9RNHXT0caQuoeT9geCFAezDXiezKoX2d9vQ5J355ZouPrS0pSJ/LWI4BzvGYxn1VW/hV4pgLLgSv9d88kes45xTWH3PEqS4ZDiWbRXioqqlab8V0tpgSWndJF8kWVWXs+wrt6K7BU73wB6bei1uFuKT3bHrPJGJPIMzS6/bBwdkxEZ5/vPmjZM3xYZI9l+N7fmlprYS8UN2bM6qnnlcDczyxoGjHYAKAoAGt6BJ5sd6u68ouIAEmpN26RDW481//Z',
              imagePosition: 'right',
              backgroundImageOpacity: 0.03,
              backgroundColor: '#F2E4C8',
            },
            articles: [
              {
                url: 'https://www.outdoorsy.com/blog/the-best-winter-beach-vacations-in-the-u-s',
                imageUrl: WarmerClimatesArticle1ImageUrl,
                imageBlurDataUrl:
                  'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEAkACQAAD/2wBDAAMCAgICAgMCAgIDAwMDBAYEBAQEBAgGBgUGCQgKCgkICQkKDA8MCgsOCwkJDRENDg8QEBEQCgwSExIQEw8QEBD/2wBDAQMDAwQDBAgEBAgQCwkLEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBD/wAARCAANAA8DAREAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAABgcI/8QAJhAAAgECBQIHAAAAAAAAAAAAAQIDBAUABgcRQSExCBIVIkJRgf/EABYBAQEBAAAAAAAAAAAAAAAAAAUGB//EACgRAAEBBgQGAwAAAAAAAAAAAAEEAAIDBREhMUFRkQYTMmFxgTOhsf/aAAwDAQACEQMRAD8A0/lfxAZ1eanpblpNDZ2qULwC5XQI8gBA9sYBY9SB+4SmDyBHd+NsM9CRq03I4c3mPwpbWxNDTMgGlQM/TVnLmot2utG9XV2SloCkhiZHaRSGAB+QHDDtzv8AWB3lUIAHPyKbtUuoFAeIsB4NdtPfbEFhNn09ymhe8+liSeJjMjSyPIwYc+ZiTwMHRkkKNWLEFTb6wZpLMlCeieC9QVPfqF8dQwHUnPmZLVeEoLJXvQQqnaLYbt3JPTGfz6dLIKjlJ3y46NG1nhThqXq0pjLHOY8Tn+N//9k=',
                title: 'Best beach vacations in the U.S.',
                description: 'Feel the heat',
                backgroundColor: '#00A876',
              },
              {
                url: 'https://www.outdoorsy.com/blog/traveling-south-during-winter-in-your-rv',
                imageUrl: WarmerClimatesArticle2ImageUrl,
                imageBlurDataUrl:
                  'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEAkACQAAD/2wBDAAMCAgICAgMCAgIDAwMDBAYEBAQEBAgGBgUGCQgKCgkICQkKDA8MCgsOCwkJDRENDg8QEBEQCgwSExIQEw8QEBD/2wBDAQMDAwQDBAgEBAgQCwkLEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBD/wAARCAANAA8DAREAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAABgcI/8QAIxAAAQQBAwUBAQAAAAAAAAAAAQIDBAURAAYSBxMhIjEyUf/EABgBAAMBAQAAAAAAAAAAAAAAAAQFBgED/8QAKBEAAQMDAwMDBQAAAAAAAAAAAQIDEQAEMRJRYQVBcQYjoRMUISKB/9oADAMBAAIRAxEAPwDaW6t2bRhS4dbKhJS7YlQZUpxQQSnHpy445HOQn6cHHzXb3WhrIJSMkCY8jMcjHeptCrW8V9JBSFnAJjVwCRE8Eye1DJzG2bxtMisrLF9CicOMxzx8Eg/opP0EfNGtO6hKVA/2kt62bZehbSwfB+N6eW3Tqt3NQrhPWEiM0vPeLaG3FuN4wUZcSoJ/vIAEEDGl1w465+jSyg7iJ+R+KoOmWVnb+++0HdgqYncwRPjFQC13BN2L1dj9KkSJVnTWUAzITst8rlQwhJJaW6Qe+j08FY5JyPYgY1t50Jm9Y+5bUW3MEjCuSMTzR3SPV1zYvmzeQHWcpSrKe8JVkDjav//Z',
                title: 'Itineraries for traveling south',
                description: 'Plot your route',
                backgroundColor: '#00A876',
              },
              {
                url: 'https://www.outdoorsy.com/blog/rving-with-kids-a-guide-to-family-friendly-travel',
                imageUrl: WarmerClimatesArticle3ImageUrl,
                imageBlurDataUrl:
                  'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEAkACQAAD/2wBDAAMCAgICAgMCAgIDAwMDBAYEBAQEBAgGBgUGCQgKCgkICQkKDA8MCgsOCwkJDRENDg8QEBEQCgwSExIQEw8QEBD/2wBDAQMDAwQDBAgEBAgQCwkLEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBD/wAARCAANAA8DAREAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAACAYH/8QAKBAAAgICAQIEBwEAAAAAAAAAAQIDBAYRBQAHEhMhMRQVIjJBUXGh/8QAFgEBAQEAAAAAAAAAAAAAAAAABgQF/8QAJREAAQMDBAICAwAAAAAAAAAAAQIDEQQhMQAFEkEUcQZRQrHh/9oADAMBAAIRAxEAPwBAdku9aZpLxdkY9f5GuqEtYTYEccW1FgSPpJSwKsUJ8Xr+weiVNt1fTOIL6AoQLBQ5i2Skn3nPWnVbvGz7gh/w3SiCqCUKLahyjiFgEDq4xMHuNn4vn8dbLJOehy34r5koHkOD9iq3hKknQIO9/j+a6tSadup5reuro5tP671mu+U9QBlunsj8h9mDe3Yx/dFnt/2dv4ni+M3L/cvIr4apOyVofKq14UJEgVFCsw+oAkljsj21telNW2h92SLnvBtBFxBi2J0I2p96jpiEKkC8ESLyDAMiSDmJGrLAV4u7lqUzUuTCSGVpJLt5rDuR7HWlUHQA9FH+9SVmz063kB8BQIJxAHrWlQfIqtNI6qnJQUlImSSZ+8THrFsDX//Z',
                title: 'A guide to family-friendly RVing',
                description: 'Bring the kids',
                backgroundColor: '#00A876',
              },
            ],
            readingList: {
              title: 'Year round camping available',
              marginBottom: 40,
              items: [
                {
                  url: 'http://www.outdoorsy.com/blog/winter-festivals-to-travel-south-for-this-winter',
                  title: `Winter festivals worth the drive`,
                  linkText: 'Catch a snowflake',
                },
                {
                  url: 'https://www.outdoorsy.com/blog/10-best-surfing-campsites-on-the-west-coast',
                  title: `10 surfing campsites in the West`,
                  linkText: 'Wax your board',
                },
                {
                  url: 'https://www.outdoorsy.com/promos/pet-friendly-rv-rentals',
                  title: `Pet-friendly RV rentals`,
                  linkText: 'Wipe their paws',
                },
              ],
            },
          },
        ]}
      />
    </>
  );
};

export default SeasonalWinterGuides;
